import styled from 'styled-components';

export const StyledSkipLink = styled.a`
  position: absolute;
  top: 8px;
  left: 8px;
  z-index: 2000;
  padding: 8px 16px;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.palette.common.white};
  color: ${({ theme }) => theme.palette.primary.main};
  font-weight: 500;
  box-shadow: 0 2px 8px ${({ theme }) => theme.shadows.dark};
  transform: translateY(-200%);

  &:focus {
    transform: none;
  }
`;

export const SkipTarget = styled.span`
  width: 0;
  height: 0;
  outline: none;
`;

export const FocusStart = styled.span`
  outline: none;
`;
